<template>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" :show-close="false" :close-on-click-modal="false">
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-form-item label="套餐名称" :label-width="'120px'" prop="packageName">
                <el-input v-model="form.packageName" placeholder="请填写套餐名称" clearable />
            </el-form-item>
            <el-form-item label="套餐类型" :label-width="'120px'" prop="packageType">
                <el-select v-model="form.packageType" placeholder="请选择套餐类型">
                    <el-option label="优享" :value="0"></el-option>
                    <el-option label="畅享" :value="1"></el-option>
                    <el-option label="尊享" :value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="原价" :label-width="'120px'" prop="originalPrice">
                <el-input v-model="form.originalPrice" placeholder="请填写原价" clearable />
            </el-form-item>
            <el-form-item v-if = "form.buyType===0" label="售价" :label-width="'120px'" prop="price">
                <el-input v-model="form.price" placeholder="请填写售价" clearable />
            </el-form-item>
            <el-form-item v-if = "form.buyType===1" label="积分" :label-width="'120px'" prop="price">
                <el-input v-model="form.price" placeholder="请填写售价" clearable />
            </el-form-item>
          <el-form-item label="购买类型" :label-width="'120px'" prop="buyType">
            <el-select v-model="form.buyType" placeholder="请选择购买类型">
              <el-option label="现金" :value="0"></el-option>
              <el-option label="积分" :value="1"></el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="套餐说明" :label-width="'120px'">
                <el-input v-model="form.description" type="textarea" placeholder="请填写套餐说明" clearable />
            </el-form-item>
            <el-form-item label="套餐月数" :label-width="'120px'" prop="packageDays">
                <el-input v-model="form.packageDays" placeholder="请填写套餐月数" clearable />
            </el-form-item>
            <el-form-item label="流量/月" :label-width="'120px'" prop="flow">
                <el-input v-model="form.flow" placeholder="请填写流量" clearable />
            </el-form-item>
          <el-form-item label="返券数量" :label-width="'120px'" prop="flow">
            <el-input v-model="form.couponsNum" placeholder="请填写返券数量" clearable />
          </el-form-item>
          <el-form-item label="排序" :label-width="'120px'" prop="flow">
            <el-input v-model="form.sort" placeholder="请填写排序" clearable />
          </el-form-item>
            <el-form-item label="状态" :label-width="'120px'">
                <el-switch v-model="form.state" :active-value="0" :inactive-value="1" />
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="addVersions">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import WifiApi from '@/api/wifi.js'
export default {
    props: ['message', 'curId'],
    data() {
        return {
            dialogFormVisible: false,
            form: {
                packageName: '',
                packageType: 0,
                originalPrice: 0,
                price: 0,
                description: '',
                flow: 0,
                couponsNum: 0,
                sort: 1,
                state: 0,
                buyType: 0
            },
            rules: {
                packageName: [
                    { required: true, message: '请输入套餐名称', trigger: 'blur' },
                ],
                originalPrice: [
                    { required: true, message: '请输入原价', trigger: 'blur' },
                ],
                price: [
                    { required: true, message: '请输入售价', trigger: 'blur' },
                ],
                packageDays: [
                    { required: true, message: '请输入套餐月数', trigger: 'blur' },
                ],
                flow: [
                    { required: true, message: '请输入流量', trigger: 'blur' },
                ],
              couponsNum: [
                { required: true, message: '请输入返券数量', trigger: 'blur' },
              ],
            },
            title: '添加套餐'
        }
    },
    methods: {
        // 关闭组件
        handleCancel() {
            this.form = {
                packageName: '',
                packageType: 0,
                originalPrice: 0,
                price: 0,
                description: '',
                flow: 0,
                couponsNum:0,
                sort: 1,
                state: 0,
                buyType: 0
            }
            this.dialogFormVisible = false // 关闭弹窗
            this.$emit('closeFunction', this.dialogFormVisible) // 传递数据给父组件
        },
        addVersions() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    const api = this.curId ? WifiApi.updatePackage : WifiApi.addPackage
                    const params = this.form
                    if(this.curId) {
                        params.id = this.curId
                    }
                    api({ ...params }).then(res => {
                        this.$message({
                            message: '添加成功',
                            type: 'success'
                        })
                        this.dialogFormVisible = false // 关闭弹窗
                        this.$emit('add-success', this.dialogFormVisible)
                    })
                }
            })
        },
    },
    mounted() {
    },
    watch: {
        message(newVal) {
            this.dialogFormVisible = newVal // 监视 props 的变化，将值赋给子组件的 data 属性
        },
        curId() {
            this.title = this.curId ? '编辑套餐' : '添加套餐'
            if(this.curId) {
                WifiApi.getPackageDetail({ id: this.curId }).then(res => {
                    this.form = {...res.data}
                })
            }
        }
    }
}
</script>

<style scoped>
.ml {
    margin-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/ybwifi/package/components/AddView.vue